<script setup>
import { formattedDate, getAge, swalError } from '@/helper';
import { get_user } from '@/services/user';
import { onMounted, ref } from 'vue';

const props = defineProps({
  child: {
    type: Object
  }
})

onMounted(async()=>{
  await retrieve_user()
})

const user_data = ref({name : ''})
async function retrieve_user(){
  let user_id = props.child.relationships.user.data.id
  let response = await get_user(user_id)
  if (response.error){
    swalError(response.message)
    return 
  }
  user_data.value.name = `${response.data.data.attributes.first_name} ${response.data.data.attributes.last_name}` 
  user_data.value.id = response.data.data.id
}
</script>

<template>
  <div class="card">
    <div class="card-header card-no-border">
      <h5 class="m-0">General Information</h5>
    </div>
    <div class="card-body pt-0">
      <p class="info-highlight">
        Name: 
        <span>{{ child.attributes?.name }}</span>
      </p>
      <p class="info-highlight">
        Age: 
        <span>{{ child.attributes ? getAge(child.attributes.date_of_birth) : 'Error' }}</span>
      </p>
      <p class="info-highlight">
        Date of Birth: 
        <span>{{ formattedDate(child.attributes?.date_of_birth) }}</span>
      </p>
      <p class="info-highlight">
        Gender: 
        <span class="text-capitalize">{{ child.attributes?.gender }}</span>
      </p>
      <p class="info-highlight">
        User Account: 
        <span class="text-capitalize">
          <router-link :to="{name: 'user', params: {id: user_data.id}}">
            {{ user_data.name }}
          </router-link>
        </span>
      </p>
    </div>
  </div>
</template>